var dayjs = require('dayjs')
var utc = require('dayjs/plugin/utc') // dependent on utc plugin
var timezone = require('dayjs/plugin/timezone')
dayjs.extend(utc)
dayjs.extend(timezone)

export default class DateUtil {
  static getTz() {
    let timezoneOffset = new Date().getTimezoneOffset()
    let hour, minute
    if (timezoneOffset <= 0) {
      hour = Math.floor(-timezoneOffset / 60)
      minute = -timezoneOffset % 60
    } else {
      hour = Math.ceil(-timezoneOffset / 60)
      minute = timezoneOffset % 60
    }
    return hour + ':' + minute
  }

  static getTzHour (){
    let timezoneOffset = new Date().getTimezoneOffset()
    let minute = -timezoneOffset
    return minute
  }

  static formatDateStringToDateOnly(dateString) {
    return dayjs(dateString).format('YYYY-MM-DD')
  }

  //服务端返回的时间,都按实际tz值转换,忽略夏令时影响
  static formatDateStringToSeconds(dateString) {
    return dayjs(dateString).utcOffset(this.getTzHour(), true).unix()
  }
  static today() {
    return dayjs().format('YYYY-MM-DD HH:mm:ss')
  }

  //从unix秒数转换为日期格式时,dayjs自动适用夏令时
  static formatSecondsToDateString(seconds) {
    return dayjs.unix(seconds).format('YYYY-MM-DD HH:mm:ss')
  }

  static todayLong() {
    return dayjs().unix()
  }

  static yearAgoLong() {
    return dayjs().subtract(1, 'year').unix()
  }

  static monthAgoLong(month) {
    return dayjs().subtract(month, 'month').unix()
  }

  static getFirstDayOfMonth(date) {
    return dayjs(date).startOf('month').format('YYYY-MM-DD HH:mm:ss')
  }

  static getLastDayOfMonth(date) {
    return dayjs(date).endOf('month').format('YYYY-MM-DD HH:mm:ss')
  }

  static formatDateToLong(date) {
    return dayjs(date).unix()
  }

  static currentDay() {
    return dayjs().format('YYYY-MM-DD')
  }

  static formatDateStringToDay(dateString) {
    return dayjs(dateString).format('YYYY-MM-DD')
  }

  static formatDateStringToHour(dateString) {
    return dayjs(dateString).format('H')
  }

  static formatDateStringToWeek(dateString) {
    return dayjs(dateString).day()
  }
}
